/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_DescInputs */

const en_model_desc = /** @type {(inputs: Model_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which model writes your PRD, features and agent replies. Small helper steps always use a fast model regardless of this choice.`)
};

const id_model_desc = /** @type {(inputs: Model_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model yang menulis PRD, fitur, dan balasan agent. Langkah bantu kecil selalu memakai model cepat apa pun pilihan ini.`)
};

/**
* | output |
* | --- |
* | "Which model writes your PRD, features and agent replies. Small helper steps always use a fast model regardless of this choice." |
*
* @param {Model_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_desc = /** @type {((inputs?: Model_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_desc(inputs)
	return en_model_desc(inputs)
});